import { useMsal } from "@azure/msal-react";
import { useCallback } from "react";

export function useLogout() {
  const context = useMsal();
  return useCallback(async () => {
    await context.instance.clearCache();
    window.location.reload();
  }, [context.instance]);
}
